import { PageController } from '@client/components/_core/layout/PageController';
import { DocumentLibrary } from '@client/components/_shared/documents/DocumentLibrary';
import { claimFormStore } from '@client/routes/~console.$orgId/~claims/~details.$id/store';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/library',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Library',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    // CUR-725: a closed claim's financial libraries are read-only (the server rejects the writes).
    const isReadonly = claimFormStore.use.isReadonly();

    return (
        <PageController route={Route}>
            <DocumentLibrary
                entity="reserve"
                entityId={Route.useParams().reserveId}
                showDownloadAllButton
                disableUploading={isReadonly}
                readOnly={isReadonly}
            />
        </PageController>
    );
}
